import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 border-t border-dark-border text-center px-4" data-id="element-125" data-mp="32wd2cf6gdjt0">
      <div className="max-w-4xl mx-auto" data-id="element-126" data-mp="3gg0yw2enzvx4">
        <p className="text-gold-dark text-sm" data-id="element-127" data-mp="3gh3n22klrk9c">
          © {new Date().getFullYear()} Yoga Teacher Ready™ — All Rights
          Reserved.
        </p>
      </div>
    </footer>;
}